import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProductSlider from '../ProductSlider';
import { supabase } from '../../lib/supabaseClient';
import { Helmet } from 'react-helmet';

const ModernLanding = () => {
  const [productosDestacados, setProductosDestacados] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const fetchDestacados = async () => {
      try {
        const { data, error } = await supabase
          .from('productos')
          .select('*')
          .eq('disponible', true)
          .limit(8);

        if (!error && data && data.length > 0) {
          setProductosDestacados(data);
        } else {
          // Fallback con productos de catálogo
          setProductosDestacados([
            {
              id: 1,
              producto: 'Proyector Inteligente 2000 Lm Videobeam',
              sku: '100001',
              precio_cliente: 129990,
              imagen_1: '/fondos/fondo2.webp',
              puntos_regalo: 150,
            },
            {
              id: 2,
              producto: 'Cerradura Inteligente Touch Wifi + Huella',
              sku: '100002',
              precio_cliente: 89990,
              imagen_1: '/fondos/fondo3.webp',
              puntos_regalo: 100,
            },
            {
              id: 3,
              producto: 'Cafetera Expresso Sicilia Valerius 4en1',
              sku: '100003',
              precio_cliente: 124990,
              imagen_1: '/fondos/fondo4.webp',
              puntos_regalo: 120,
            },
            {
              id: 4,
              producto: 'Cortadora De Arbustos De 21 V Inalámbrica',
              sku: '100004',
              precio_cliente: 249990,
              imagen_1: '/fondos/fondo5.webp',
              puntos_regalo: 250,
            },
          ]);
        }
      } catch (err) {
        console.warn('Error al cargar destacados:', err);
      } finally {
        setCargando(false);
      }
    };

    fetchDestacados();
  }, []);

  const formatPrecio = (precio) => {
    if (!precio) return '$0';
    return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(precio);
  };

  return (
    <div className="bg-[#0b0e14] text-white overflow-hidden">
      <Helmet>
        <title>MatiMarket - Marketplace Oficial & Sorteos</title>
        <meta
          name="description"
          content="Descubre MatiMarket, acumula MatiCoins, juega El Montoncito y compra productos exclusivos con garantía."
        />
      </Helmet>

      {/* Hero Slider con botón para jugar El Montoncito */}
      <ProductSlider />

      {/* Barra de Beneficios y Confianza */}
      <section className="border-y border-gold/15 bg-gradient-to-r from-[#0d1219] via-[#141b24] to-[#0d1219] py-6 px-4">
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 text-center md:text-left">
          <div className="flex items-center justify-center md:justify-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-gold/10 border border-gold/30 flex items-center justify-center text-gold flex-shrink-0">
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <div>
              <h4 className="text-xs font-bold uppercase tracking-wider text-white">Vendedores Oficiales</h4>
              <p className="text-[11px] text-gray-400">Tiendas 100% verificadas</p>
            </div>
          </div>

          <div className="flex items-center justify-center md:justify-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center text-emerald-400 flex-shrink-0">
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <h4 className="text-xs font-bold uppercase tracking-wider text-white">MatiCoins de Regalo</h4>
              <p className="text-[11px] text-gray-400">Puntos por cada compra</p>
            </div>
          </div>

          <div className="flex items-center justify-center md:justify-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center text-amber-400 flex-shrink-0">
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <div>
              <h4 className="text-xs font-bold uppercase tracking-wider text-white">Juego El Montoncito</h4>
              <p className="text-[11px] text-gray-400">Apuesta y multiplica puntos</p>
            </div>
          </div>

          <div className="flex items-center justify-center md:justify-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-blue-500/10 border border-blue-500/30 flex items-center justify-center text-blue-400 flex-shrink-0">
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
            </div>
            <div>
              <h4 className="text-xs font-bold uppercase tracking-wider text-white">Despacho Seguro</h4>
              <p className="text-[11px] text-gray-400">Envíos a todo el país</p>
            </div>
          </div>
        </div>
      </section>


      {/* SECCIÓN DEL JUEGO: EL MONTONCITO */}
      <section className="py-16 px-4 bg-gradient-to-b from-[#0b0e14] via-[#0b1613] to-[#0b0e14] border-b border-gray-800/80">
        <div className="max-w-7xl mx-auto">
          <div className="rounded-3xl glass-card border border-emerald-500/30 p-8 md:p-12 relative overflow-hidden">
            <div className="absolute -bottom-10 -right-10 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none"></div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-7 space-y-4">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/20 text-emerald-300 border border-emerald-500/40 text-xs font-bold uppercase tracking-wider">
                  <span className="w-2 h-2 rounded-full bg-emerald-400 animate-ping"></span>
                  <span>Mini-Juego En Vivo</span>
                </div>

                <h2 className="text-3xl md:text-5xl font-black text-white">
                  ¡Juega <span className="text-emerald-400">El Montoncito</span> y Multiplica tus Puntos!
                </h2>

                <p className="text-gray-300 text-sm md:text-base leading-relaxed">
                  ¿Tienes MatiCoins acumulados por tus compras o referidos? Entra a la mesa de juego, selecciona tu montón de cartas favorito y pon a prueba tu intuición para ganar más puntos y canjear premios mayores.
                </p>

                <div className="flex flex-wrap items-center gap-4 pt-3">
                  <Link
                    to="/juegos/el-montoncito"
                    className="px-8 py-4 rounded-xl font-black text-sm uppercase tracking-wider text-black bg-gradient-to-r from-emerald-400 via-teal-300 to-emerald-500 hover:from-emerald-300 hover:to-emerald-400 shadow-xl shadow-emerald-500/30 hover:scale-105 transition duration-200 flex items-center gap-2"
                  >
                    <svg className="w-5 h-5 text-black" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/>
                    </svg>
                    <span>¡JUGAR EL MONTONCITO AHORA!</span>
                  </Link>

                  <Link
                    to="/como-participar"
                    className="px-6 py-4 rounded-xl font-semibold text-xs text-gray-300 border border-emerald-500/30 hover:bg-emerald-500/10 hover:text-white transition"
                  >
                    Aprender Reglas
                  </Link>
                </div>
              </div>

              <div className="lg:col-span-5 flex justify-center">
                <Link
                  to="/juegos/el-montoncito"
                  className="group relative block w-64 h-80 rounded-2xl glass-card border-2 border-emerald-500/40 p-4 hover:scale-105 transition duration-300 shadow-2xl text-center"
                >
                  <div className="text-xs uppercase tracking-widest text-emerald-400 font-bold mb-2">
                    Mesa de Partida
                  </div>
                  <div className="w-32 h-44 mx-auto my-2 rounded-xl bg-slate-900 border-2 border-emerald-400/50 overflow-hidden shadow-lg group-hover:border-emerald-300 transition">
                    <img
                      src="/img/game/elmontoncito/reverso.png"
                      alt="Carta Montoncito"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="text-white font-bold text-sm mt-3">
                    Partidas Activas Cada Minuto
                  </div>
                  <div className="text-[11px] text-gray-400 mt-1">
                    Toca para ingresar a la sala
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CATÁLOGO DE PRODUCTOS DESTACADOS */}
      <section id="productos-destacados" className="py-20 px-4 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-gold">Selección Exclusiva</span>
            <h2 className="text-3xl md:text-4xl font-black text-white mt-1">
              Productos <span className="text-gold-gradient">Destacados</span>
            </h2>
          </div>
          <Link
            to="/productos"
            className="text-xs font-bold uppercase tracking-wider text-gold hover:text-gold-light transition flex items-center gap-1.5"
          >
            <span>Ver todo el catálogo</span>
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>

        {cargando ? (
          <div className="py-20 text-center">
            <span className="loading loading-spinner loading-lg text-gold"></span>
            <p className="mt-4 text-gray-400 text-sm">Cargando productos...</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {productosDestacados.map((prod) => (
              <div
                key={prod.id}
                className="group relative glass-card rounded-2xl overflow-hidden glass-card-hover border border-gold/20 flex flex-col justify-between"
              >
                {/* Imagen del Producto */}
                <div className="relative aspect-square w-full bg-slate-900/60 p-4 flex items-center justify-center overflow-hidden">
                  <img
                    src={prod.imagen_1 || '/fondos/fondo2.webp'}
                    alt={prod.producto}
                    className="w-full h-full object-contain group-hover:scale-105 transition duration-300"
                  />

                  {/* Badges superiores */}
                  <div className="absolute top-3 left-3 flex flex-col gap-1.5">
                    <span className="px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider bg-gold text-black shadow-sm">
                      Destacado
                    </span>

                    {prod.puntos_regalo > 0 && (
                      <span className="px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider bg-black/80 text-amber-300 border border-gold/40">
                        +{prod.puntos_regalo} Puntos
                      </span>
                    )}
                  </div>
                </div>

                {/* Contenido */}
                <div className="p-5 flex flex-col flex-grow justify-between">
                  <div>
                    <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">
                      SKU: {prod.sku || 'N/A'}
                    </span>
                    <h3 className="font-bold text-white text-sm mt-1 line-clamp-2 group-hover:text-gold transition">
                      {prod.producto}
                    </h3>
                  </div>

                  <div className="mt-4 pt-3 border-t border-gray-800 flex items-center justify-between">
                    <div>
                      <div className="text-[10px] uppercase text-gray-400">Precio</div>
                      <div className="text-lg font-black text-amber-300">
                        {formatPrecio(prod.precio_cliente)}
                      </div>
                    </div>

                    <Link
                      to={`/productos/detalle-producto/${prod.sku}/comprar`}
                      className="px-3.5 py-2 rounded-xl text-xs font-bold uppercase tracking-wider text-black bg-gold hover:bg-gold-light transition shadow-md shadow-gold/20"
                    >
                      Ver
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* CÓMO FUNCIONA MATIMARKET */}
      <section className="py-20 px-4 bg-[#0a0d12] border-t border-gray-800">
        <div className="max-w-6xl mx-auto">
          <div className="text-center max-w-2xl mx-auto mb-16">
            <span className="text-xs font-bold uppercase tracking-widest text-gold">Tu Ecosistema de Compras</span>
            <h2 className="text-3xl md:text-4xl font-black text-white mt-1">
              ¿Cómo Funciona <span className="text-gold-gradient">MatiMarket</span>?
            </h2>
            <p className="text-xs text-gray-400 mt-2">
              Un modelo innovador donde comprar no solo te da productos de alta gama, sino también opciones de ganar.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="glass-card p-8 rounded-2xl border border-gold/20 text-center space-y-4">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-gold/10 border border-gold/30 flex items-center justify-center text-gold text-2xl font-black">
                1
              </div>
              <h3 className="text-lg font-bold text-white">Compra Productos Exclusivos</h3>
              <p className="text-xs text-gray-300 leading-relaxed">
                Adquiere productos de tecnología y novedades con garantía certificada y despacho seguro directo a tu hogar.
              </p>
            </div>

            <div className="glass-card p-8 rounded-2xl border border-gold/20 text-center space-y-4">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center text-emerald-400 text-2xl font-black">
                2
              </div>
              <h3 className="text-lg font-bold text-white">Acumula MatiCoins</h3>
              <p className="text-xs text-gray-300 leading-relaxed">
                Cada compra te acredita puntos directamente a tu cuenta. También puedes sumar invitando amigos con tu código de referido exclusivo.
              </p>
            </div>

            <div className="glass-card p-8 rounded-2xl border border-gold/20 text-center space-y-4">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center text-amber-400 text-2xl font-black">
                3
              </div>
              <h3 className="text-lg font-bold text-white">Juega y Participa por Sorteos</h3>
              <p className="text-xs text-gray-300 leading-relaxed">
                Usa tus MatiCoins para jugar en <strong>El Montoncito</strong> o canjear tickets directos para los sorteos semanales de grandes premios.
              </p>
            </div>
          </div>

          <div className="text-center mt-12">
            <Link
              to="/registrate"
              className="inline-block px-8 py-4 rounded-xl font-bold uppercase tracking-wider text-black bg-gradient-to-r from-amber-400 via-yellow-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 shadow-xl shadow-gold/30 hover:scale-105 transition"
            >
              Crea tu Cuenta Gratis y Comienza Hoy
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ModernLanding;
